module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/usaa@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/usaa@2x.png
// module id = 1195
// module chunks = 0